import React from 'react';
import styled from 'styled-components';
import { Users, Eye, Briefcase } from 'lucide-react';

interface ClientRoleIndicatorChipProps {
  permissionLevel?: number;
  isSupervisor?: boolean;
}

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--surface-light);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  font-size: 12px;
  color: var(--text-secondary);
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: var(--primary-color);
`;

const ClientRoleIndicatorChip: React.FC<ClientRoleIndicatorChipProps> = ({
  permissionLevel,
  isSupervisor
}) => {
  // Determine text based on role
  const getText = () => {
    if (permissionLevel === 1) {
      return 'כל הלקוחות';
    }
    if (permissionLevel === 3 && isSupervisor) {
      return 'צפייה בכל הלקוחות';
    }
    return 'הלקוחות שלי';
  };

  // Determine icon based on role
  const getIcon = () => {
    if (permissionLevel === 1) {
      return <Users size={14} />;
    }
    if (permissionLevel === 3 && isSupervisor) {
      return <Eye size={14} />;
    }
    return <Briefcase size={14} />;
  };

  return (
    <Chip>
      <IconWrapper>{getIcon()}</IconWrapper>
      {getText()}
    </Chip>
  );
};

export default ClientRoleIndicatorChip;
